define('uikit/elements/button',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','../extra/size','../extra/color','templates'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var Templates = require('templates');

  var ButtonView = Mn.ItemView.extend(ComponentMixin).extend(
    {
      className: 'ui button',

      allowTagChange: true,

      attributes: {
        role: 'button',
      },

      triggers: {
        mousedown: { event: 'before:press', preventDefault: false, stopPropagation: false },
      },

      events: {
        keydown: function(ev) {
          if (ev.keyCode == 13 && !this.disabled) {
            this.triggerMethod('before:press', {
              view: this,
              model: this.model,
              collection: this.collection,
            });

            if (this.el.click) {
              this.el.click();
            } else {
              this.triggerMethod('press', {
                view: this,
                model: this.model,
                collection: this.collection,
              });
            }
          }
        }, // Trigger press on Enter/Return key
        click: function(ev) {
          if (this.stopPropagation) {
            ev.stopPropagation();
          }
          // adding custom trigger
          // so we can control propagation
          this.triggerMethod('press', {
            view: this,
            model: this,
            collection: this.collection,
          });
        },
      },

      options: {
        visible: true,
        text: '',
        disabled: false,
        icon: '',
        iconRight: false,
        loading: false,
        color: '',
        size: '',
        basic: false,
        basicText: false,
        inline: false,
        circular: false,
        inverted: false,
        fluid: false,
        labeled: false,
        link: '',
        active: false,
        floated: '',
        compact: false,
        stopPropagation: false,

        // Badge options
        badge: false,
        badgeText: '',
        badgeColor: 'red',
      },

      colorOptionValues: _.values(Color),
      sizeOptionValues: _.values(Size),

      forceUpdate: {
        text: true,
        icon: true,
        iconRight: true,
        badge: true,
        badgeText: true,
        badgeColor: true,
      },

      updateAttributes: function() {
        if (this.visible) {
          this.$el.attr('tabindex', 0);
        } else {
          this.$el.attr('tabindex', -1);
        }

        this.addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass(
            'icon',
            (this.getBoolOption('icon') && !this.getBoolOption('text')) ||
              (this.getBoolOption('labeled') && this.getBoolOption('icon'))
          )
          .addClass('right', this.getBoolOption('iconRight'))
          .addClass(
            'labeled',
            this.getBoolOption('icon') && this.getBoolOption('text') && this.getBoolOption('labeled')
          )
          .addClass('loading', this.getBoolOption('loading'))
          .addClass('basic', this.getBoolOption('basic') && !this.getBoolOption('basicText'))
          .addClass('inline', this.getBoolOption('basicText') || this.getOption('inline'))
          .addClass('circular', this.getBoolOption('circular'))
          .addClass('inverted', this.getBoolOption('inverted'))
          .addClass('fluid', this.getBoolOption('fluid'))
          .addClass('active', this.getBoolOption('active'))
          .addClass('compact', this.getBoolOption('compact'))
          .addClass(this.getOption('color'), this.getBoolOption('color'))
          .addClass(this.getOption('size'), this.getBoolOption('size'));

        if (this.getOption('link')) {
          if (_.isString(this.getOption('link'))) {
            this.$el.attr('href', this.getOption('link'));
          }
          if (this.getOption('target')) {
            this.$el.attr('target', this.getOption('target'));
          }
        } else {
          this.$el.removeAttr('href');
        }
      },

      template: Templates.App['button'],
    },
    {}
  );

  ButtonView.MINI = 'mini';
  ButtonView.TINY = 'tiny';
  ButtonView.SMALL = 'small';
  ButtonView.MEDIUM = 'medium';
  ButtonView.LARGE = 'large';
  ButtonView.BIG = 'big';
  ButtonView.HUGE = 'huge';
  ButtonView.MASSIVE = 'massive';

  // register the table component
  channel.reply('button', function() {
    return ButtonView;
  });

  module.exports = ButtonView;
});

